import Inbox from 'app/shared/model/Inbox';

const Inquiry = ({
    id = '',
    attributes = {},
    feed = '',
    feedListingId = '',
    dateSaved = '',
    timestamp = 0,
    contactEmail = '',
    name = '',
    email = '',
    phone = '',
    message = '',
    zip = '',
    ref = '',
    inbox = {},
    isPhoneLead = false,
    inquirerType = '',
} = {}) => ({
    id: String(id),
    attributes: Object(attributes),
    feed: String(feed),
    feedListingId: String(feedListingId),
    dateSaved: String(dateSaved),
    timestamp: Number(timestamp),
    contactEmail: String(contactEmail),
    name: String(name),
    email: String(email),
    phone: String(phone),
    message: String(message),
    zip: String(zip),
    ref: String(ref),
    inbox: Inbox(inbox),
    isPhoneLead: Boolean(isPhoneLead),
    inquirerType: String(inquirerType),
});

export default Inquiry;
